<template>
  <v-sheet class="!wd-pb-1" rounded>
    <div class="wd-px-5 wd-py-3 wd-text-xl wd-font-medium">{{ $t('title_precautions') }}</div>
    <div class="wd-px-5 wd-pt-3">
      <content-show-more v-model="isShowMore" :hide="isHideShowMoreButton">
        <div ref="noticeContainer" class="wd-mb-3" :class="isShowMore ? 'wd-line-clamp-none' : 'wd-line-clamp-6'">
          <p v-for="(text, index) in noticeUiData" :key="text + index" class="wd-inline after:wd-content-\A after:wd-whitespace-pre">
            <span class="wd-break-words">{{ text }}</span>
          </p>
        </div>
      </content-show-more>
    </div>
  </v-sheet>
</template>

<script>
import { useResizeObserver } from '@vueuse/core'
import ContentShowMore from '@/components/ContentShowMore.vue'

export default defineComponent({
  name: 'OrderPreparationNotice',
  components: {
    ContentShowMore,
  },
  props: {
    notice: { type: String, default: '' },
  },
  setup(props) {
    const noticeContainer = ref(null)
    const isShowMore = ref(false)
    const isHideShowMoreButton = ref(true)
    const noticeUiData = computed(() => props.notice.split('\n'))

    const { stop } = useResizeObserver(noticeContainer, entries => {
      isHideShowMoreButton.value = isShowMore.value ? false : entries[0].target.scrollHeight <= entries[0].target.clientHeight
    })

    onUnmounted(() => {
      stop()
    })

    return {
      noticeContainer,
      noticeUiData,
      isShowMore,
      isHideShowMoreButton,
    }
  },
})
</script>

<style></style>
